import React, {useEffect, useState} from "react";
import {useQueryClient} from "react-query";
import {useSelector} from "react-redux";
import {useSnackbar} from "notistack";

import {Column, Row} from "../../components/Layout";
import Checkbox from "../../components/Checkbox";
import NTMButton from "../../components/Buttons/NTMButton";

import { DEVICES, get, getErrorMessage, PROJECTS, put } from "../../service/Client";
import Roles from "../../constants/Roles";


export default function AssignDevicePanel({devices=[], onSave}) {

	const queryClient = useQueryClient();
	const {enqueueSnackbar} = useSnackbar();
	let project = useSelector(store => store.session.project);
	let loggedUser = useSelector(store => store.users.data)
	let [checkedDevices, setCheckedDevices] = useState()
	let [freeDevices, setFreeDevices] = useState([])

	useEffect(() => {
		if (!Roles.isSuperUser(loggedUser)) return;
		get(`${DEVICES}/unassigned/${project.id}`).then(setFreeDevices);
	}, [project, devices, loggedUser])


	function isDeviceChecked(device) {
		return checkedDevices ? checkedDevices.includes(device) : false
	}

	function setDeviceChecked(device, checked) {
		let newCheckedDevices = checkedDevices?.slice() || []
		if (checked) {
			newCheckedDevices.push(device)
		} else {
			newCheckedDevices = newCheckedDevices.filter(d => d !== device)
		}
		setCheckedDevices(newCheckedDevices)
	}

	function saveDevice() {
		put(`${PROJECTS}/${project.id}/devices`, {body:[...devices, ...checkedDevices]})
			.then(() => onSave && onSave())
			.catch(e => enqueueSnackbar(getErrorMessage(e), {variant: "error"}))
			.finally(() => {
				if (project.projectTypeId === 4) {
					queryClient.invalidateQueries('switch')
				} else {
					queryClient.invalidateQueries('devices')
				}
			})
	}

	return <Column>{Roles.isSuperUser(loggedUser) && <>
		<Row style={{color:"#D8232A", paddingTop:"1rem", paddingBottom:"1rem", fontWeight:"bold"}}>Associa un nuovo dispositivo</Row>
		{
			freeDevices.map(free => <Row key={free.deviceId}>
				<Checkbox
					color="red"
					checked={isDeviceChecked(free.deviceId)}
					onCheck={e => setDeviceChecked(free.deviceId, e.target.checked)}
				/>
				{free.deviceId}
			</Row>)
		}
		<NTMButton primary onClick={saveDevice}>Associa</NTMButton>
	</>}</Column>

}
